export default __webpack_public_path__ + "static/media/H1015.2.c88e39ce.mp3";